import React, { createContext } from 'react';
import { UserNotificationContextProps } from './userNotification.interface';

export const UserNotificationContext =
  createContext<UserNotificationContextProps>({
    notifications: [],
    addUserNotification: () => {},
    removeNotification: () => {},
  });
